<!-- <ng-container *ngIf="lookupdata.length > 0"> -->
<section class="mx-3">
  <ng-container>
    <div class="d-flex justify-content-between align-items-center">
      <div class="page_header">
        <h3 translate class="m-0 page_header_title">Academic Regulations List</h3>
      </div>
      <div *ngIf="actiondata?.create">
        <button
          mat-raised-button
          color="primary"
          (click)="openAddAcademicsDialog()"
          class="px-5 add_button"
        >
        <i class="fa-solid fa-plus"></i>
         <span> Add </span>
        </button>
      </div>
    </div>
    <div class="position-relative">
      @if (isLoadingResults || isRateLimitReached) {
      <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner class="mat_spinner"></mat-spinner>
        } @if (isRateLimitReached) {
        <div class="rate-limit-reached">
          Sorry!.. for Incovience  
        </div>
        }
      </div>
      }
      <ng-container *ngIf="actiondata?.list_view">
      <div class="mt-2 table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <ng-container matColumnDef="code">
            <th translate mat-header-cell *matHeaderCellDef>Regulation Code</th>
            <td mat-cell *matCellDef="let element">{{ element.code }}</td>
          </ng-container>
          <ng-container matColumnDef="start_year">
            <th translate mat-header-cell *matHeaderCellDef>Batches</th>
            <td mat-cell *matCellDef="let element">
              {{ element.start_year }} - {{ element.end_year }}
            </td>
          </ng-container>
          <ng-container matColumnDef="courses">
            <th translate mat-header-cell *matHeaderCellDef>Courses</th>
            <td mat-cell *matCellDef="let element">
                {{ element.course_name }}
            </td>
          </ng-container>

          <ng-container *ngFor="let course of courseData">
            <ng-container matColumnDef="{{ course.field }}">
              <th mat-header-cell *matHeaderCellDef>{{ course.header }}</th>
              <td mat-cell *matCellDef="let element">
                {{ element[course.field] }}
              </td>
            </ng-container>
          </ng-container>

          <ng-container matColumnDef="description">
            <th translate mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element">
              <div class="description-container">
                {{ element.description }}
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="Sections">
            <th translate mat-header-cell *matHeaderCellDef>Sections</th>
            <td mat-cell *matCellDef="let element">
              <div class="d-flex align-items-center">
                <ng-container *ngIf="element.sections.length > 0">
                  {{ getSectionNames(element.sections) }}
                </ng-container>
              <ng-container *ngIf="actiondata?.create && filteraddbutton(element.sections)"> 
                <!-- <button mat-raised-button (click)="openCreateSectionDialog(element)">Add Sections</button> -->
                <div  mat-icon-button class="add_btn_bule_circle ms-1 me-2" (click)="openCreateSectionDialog(element)">
                  <i class="fa-solid fa-circle-plus"></i>
                </div>
              </ng-container>
            </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              <p translate class="m-0 action_button cursor_pointer" (click)="showsemesterdetails(row)">
                View
              </p>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="selection.toggle(row)"
          ></tr>
          <tr class="mat-row" *matNoDataRow>
            <td translate class="mat-cell" colspan="4">No data</td>
          </tr>
        </table>
      </div>
      <div class="mt-2" *ngIf="total_count > 5">
        <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
      </div>
    </ng-container>
    </div>
  </ng-container>

    <!-- Create Section Dialog Template -->
<ng-template #createSectionDialog>
  <app-toast></app-toast>
  <div class="m-3">
  <h4 translate mat-dialog-title>Add Sections</h4>
  <form (ngSubmit)="onSubmit()" [formGroup]="createsectionForm">
  <div mat-dialog-content class="my-4">
    <div *ngFor="let question of createsection" class="question-container">
      <app-question [question]="question" [form]="createsectionForm"></app-question>
    </div>
  </div>
  <div mat-dialog-actions class="dialog-actions d-flex justify-content-end">
    <button translate mat-stroked-button class="cancel_button me-2" (click)="closeDialog(true)">Cancel</button>
    <button translate mat-flat-button class="submit_button" color="primary" type="submit" [disabled]="!createsectionForm.valid">Submit</button>
  </div>
</form>
</div>
</ng-template>

</section>
